import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        margin: theme.spacing(2, 0),
      },
      rowPresencaTipo: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'default',
        '& svg': {
          width: '24px',
          height: '24px',
        },
      },
      box: {
        borderRadius: 4,
        backgroundColor: 'white',
      },
      title: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 'bold',
        fontSize: 12,
        color: sicrediColors.secondarySicrediDarker,
        letterSpacing: 0.25,
        lineHeight: 1.2,
        padding: theme.spacing(1),
        borderBottomWidth: 16,
        borderBottomColor: '#F8F9F7',
        whiteSpace: 'pre-wrap',
      },
      data: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 12,
        color: sicrediColors.secondarySicrediDark,
        letterSpacing: 0.44,
        lineHeight: 1.2,
        padding: theme.spacing(2, 1),
      },
      noBreakingData: {
        whiteSpace: 'nowrap',
      },
      navIcon: {
        color: sicrediColors.primarySicrediDark,
      },
    }),
  { name: 'RelatorioTabela' }
);
